// extracted by mini-css-extract-plugin
export var growableInput = "_aa-0";
export var tagContainer = "_aa-2";
export var textInput = "_aa-1";